export enum metadataDomain {
  GITLAB = "gitlab"
}

export enum metadataType {
  ISSUE = "issue",
  MERGE_REQ = "merge request",
  GENERIC = "generic"
}
